import { useEffect, useState, useRef } from "react";
import { FaCheck, FaSearch } from "react-icons/fa";
import { FaCircleInfo } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import {
  AddCharty,
  EstateBeneficiarySetList,
  FindCharity,
} from "../../api/get";
import {
  AddBeneficiary,
  SaveEstateDevidedData,
  ifDiesSaveEstate,
} from "../../api/api";
import toast from "react-hot-toast";
import Modal from "react-responsive-modal";
import FloatingLabelInput from "../../Common/FloatingLabel";
import Loader from "../../loader";
import Header from "../../Common/Header";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";
import { useParams } from "react-router-dom"; // Import useParams to get URL parameters
import { useFormik } from "formik";
import * as Yup from "yup";
import { Toaster } from "react-hot-toast";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { FaInfoCircle } from "react-icons/fa";
import Spinner from "../../Common/Spinner";
import { handleApiError } from "../../Common/Helper";
const PartnerDiesComp = () => {
  const [radio, setRadio] = useState();
  const [diesCurrentBeneficiary, setDiesBeneficiaries] = useState([]);
  const [contentLoader, setContentLoader] = useState(true);
  const { estate_beneficiary_id } = useParams(); // Extract 'id' and 'type' from URL
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("dd/mm/yyyy");
  const [isFocused, setIsFocused] = useState(false);
  const freeSearchInputRef = useRef(null); // Create a ref for the search input container
  const [selectedCharities, setSelectedCharities] = useState([]); // To store the selected charities
  const [availableCharities, setAvailableCharities] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    EstateBeneficiarySetList()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          var estateBeneficiaryId = estate_beneficiary_id;
          const record = res.data.find(
            (item) => item.id == estateBeneficiaryId
          );
          if (record.if_dies_estate_goes_to === "children") {
            setRadio(0); // Select the first radio button
          } else if (record.if_dies_estate_goes_to === "anything_else") {
            setRadio(1); // Select the second radio button
          }
          setDiesBeneficiaries(record);
          setContentLoader(false);
        } else {
          handleApiError(res, navigate); // Use helper function
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [estate_beneficiary_id]);
  console.log("diesCurrentBeneficiary =>", diesCurrentBeneficiary);

  const [selectedCharityData, setSelectCharityData] = useState([]);
  const [devideValue, setDevideValue] = useState(0);
  const [percentages, setPercentages] = useState(
    Array(selectedCharityData.length).fill("0")
  );
  const [openModal, setOpenModal] = useState();
  const [addBeneficiary, setaddBeneficiary] = useState([]);
  const [charityData, setCharityData] = useState([]);
  const [charityModal, setcharityModal] = useState();
  const [beneficiaryModel, setBeneficiaryModel] = useState();
  const [searchCharity, setSearchCharity] = useState([]);
  const [saveCharity, setSaveCharity] = useState([]);
  const [searchCharityData, setSearchCharityData] = useState([]);
  const [percentageData, setPercentageData] = useState(
    selectedCharityData.map((item) => ({
      beneficiary_id: item.id,
      beneficiary_percentage: "0",
    }))
  );
  const isSelected = (id) =>
    selectedCharities.some((charity) => charity.id === id);

  console.log("selectedCharities =>", selectedCharities);

  const [searchInput, setSearchInput] = useState("");
  const onCloseModel = () => {
    setBeneficiaryModel(false);
    formikAddBeneficiary.resetForm(); // Reset the form on modal close
  };
  const handleChange = (e) => {
    setaddBeneficiary({ ...addBeneficiary, [e.target.name]: e.target.value });
  };
  const formatDateToYMD = (dob) => {
    if (!dob || dob === "undefined" || dob.trim() === "") {
      return ""; // Return an empty string if the input is invalid
    }
    // Assuming `dob` is in "dd/mm/yyyy" format
    const [day, month, year] = dob.split("/");
    if (!day || !month || !year) {
      return ""; // Return empty if any part is missing
    }
    return `${year}-${month}-${day}`; // Convert to "yyyy-mm-dd"
  };
  const navigate = useNavigate();

  const handleSearchCharity = (e) => {
    const inputValue = e.target.value.trim(); // Remove any extra whitespace
    setSearchInput(inputValue);
    if (inputValue.length !== 0) {
      // Assuming `selectedCharities` is an array holding the selected charity IDs
      const charitiesIds = diesCurrentBeneficiary.inherit_charities_data.map(
        (charity) => charity.charity_id
      );
      const type = "with_default_charity";
      FindCharity(inputValue, charitiesIds, type)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            console.log(res);
            setSearchCharity(res.data);
            // setSearchInput(e.target.value);
          } else {
            handleApiError(res, navigate); // Use helper function
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setSearchCharity([]);
    }
  };

  const handleClickOutside = (e) => {
    if (
      freeSearchInputRef.current &&
      !freeSearchInputRef.current.contains(e.target)
    ) {
      // If the click is outside the free_search_input, reset searchInput
      setSearchInput("");
    }
  };

  // Adding event listener when the component mounts
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []); // Empty dependency array means this runs only once when the component mounts
  const handleDivClick = (data) => {
    const isAlreadySelected = selectedCharities.some(
      (charity) => charity.id === data.id
    );

    if (isAlreadySelected) {
      // Remove the selected charity if already present
      setSelectedCharities((prev) =>
        prev.filter((charity) => charity.id !== data.id)
      );
    } else {
      // Add the charity to the selected list
      // setSelectedCharities((prev) => [...prev, data]);
      setSelectedCharities((prev) => [...prev, { ...data, is_selected: true }]);
    }
  };
  const appendCharity = (appendData) => {
    const modifiedAppendData = appendData.map((data) => ({
      charity_id: data.id, // Rename id to charity_id
      ...data, // Spread the rest of the properties
      percentage: "", // Add percentage flag with a default value
      // Optionally remove the original id field if not needed
    }));

    setDiesBeneficiaries((prevState) => {
      // Create a copy of the previous state
      const updatedBeneficiary = { ...prevState };

      // Filter out charities that are not already in `inherit_charities_data`
      const newCharities = modifiedAppendData.filter(
        (data) =>
          !updatedBeneficiary.inherit_charities_data.some(
            (charity) => charity.charity_id === data.charity_id
          )
      );

      // Append new charities to `inherit_charities_data`
      updatedBeneficiary.inherit_charities_data = [
        ...updatedBeneficiary.inherit_charities_data,
        ...newCharities,
      ];

      return updatedBeneficiary; // Return the updated state
    });

    setcharityModal(false); // Close the modal if required
  };

  const validationSchema = Yup.object().shape({
    save_charities: Yup.array().of(
      Yup.object().shape({
        charity_id: Yup.number().required("Charity ID is required"),
        charity_percentage: Yup.number()
          .required("Percentage is required")
          .min(0, "Percentage cannot be less than 0")
          .max(100, "Percentage cannot exceed 100")
          .notRequired(), // Make the field optional,
      })
    ),
    save_beneficiaries: Yup.array().of(
      Yup.object().shape({
        beneficiary_id: Yup.number().required("Beneficiary ID is required"),
        beneficiary_percentage: Yup.number()
          .required("Percentage is required")
          .min(0, "Percentage cannot be less than 0")
          .max(100, "Percentage cannot exceed 100")
          .notRequired(), // Make the field optional,
      })
    ),
  });
  const formik = useFormik({
    initialValues: {
      save_charities: (diesCurrentBeneficiary.inherit_charities_data || []).map(
        (charity) => ({
          charity_id: charity.charity_id,
          charity_percentage: charity.percentage || "",
        })
      ),
      save_beneficiaries: (
        diesCurrentBeneficiary.inherit_benficiaries || []
      ).map((beneficiary) => ({
        beneficiary_id: beneficiary.id,
        beneficiary_percentage: beneficiary.percentage || "",
      })),
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      const if_dies_estate_goes_to = radio == 0 ? "children" : "anything_else";
      const own_beneficiary_id = diesCurrentBeneficiary.beneficiary_id;
      // Filter out empty percentages
      const filteredValues = {
        estates_beneficiaries_id: estate_beneficiary_id,
        if_dies_estate_goes_to,
        own_beneficiary_id,
        ...(radio !== 0 && {
          save_charities: values.save_charities.filter(
            (charity) => charity.charity_percentage !== ""
          ),
          save_beneficiaries: values.save_beneficiaries.filter(
            (beneficiary) => beneficiary.beneficiary_percentage !== ""
          ),
        }),
      };

      console.log("Filtered Values =>", filteredValues);
      // Call the API with the filtered data
      ifDiesSaveEstate(filteredValues)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            toast.success("divided successfully");
            if (diesCurrentBeneficiary.next_id != 0) {
              navigate(
                `/make-will-online/estate/inheritance/${diesCurrentBeneficiary.next_id}`
              );
            } else {
              navigate("/make-will-online/estate/gifts");
            }
          } else {
            handleApiError(res,navigate);
          }
          setLoading(false);
        })
        .catch((err) => {
          toast.error("An error occurred while saving the data.");
          console.error(err);
        })
        .finally(() => {
          setContentLoader(false);
        });
    },
  });
  const calculateDevideValue = (values) => {
    const totalCharity = values.save_charities.reduce(
      (sum, charity) => sum + Number(charity.charity_percentage || 0),
      0
    );
    const totalBeneficiary = values.save_beneficiaries.reduce(
      (sum, beneficiary) =>
        sum + Number(beneficiary.beneficiary_percentage || 0),
      0
    );
    return totalCharity + totalBeneficiary;
  };
  useEffect(() => {
    setDevideValue(calculateDevideValue(formik.values));
  }, [formik.values]);

  const validationSchemaForbeneficiary = Yup.object().shape({
    beneficiary_first_name: Yup.string().required("Required field"),
    beneficiary_last_name: Yup.string().required("Required field"),
    beneficiary_email: Yup.string().email("Invalid email address"),
    beneficiary_dob: Yup.string()
      .nullable()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
        "Date of birth must be in dd/mm/yyyy format"
      )
      .test("is-past-date", "Date must be in the past", (value) => {
        if (!value) return true; // Skip if empty
        const [day, month, year] = value.split("/");
        const enteredDate = new Date(`${year}-${month}-${day}`);
        return enteredDate < new Date();
      })
      .test(
        "is-after-1900",
        "Please enter a date of birth after 1900",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          return parseInt(year) > 1900;
        }
      ),
  });
  const formikAddBeneficiary = useFormik({
    initialValues: {
      beneficiary_first_name: "",
      beneficiary_last_name: "",
      beneficiary_email: "",
      beneficiary_dob: "",
      beneficiary_location: "",
      beneficiary_live_at_my_address: "",
    },
    validationSchema: validationSchemaForbeneficiary, // Apply validation schema
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      // Convert "date_of_birth" from "dd/mm/yyyy" to "dob" with "dd-mm-yyyy"
      const transformedValues = {
        ...values,
        beneficiary_dob: values.beneficiary_dob
          ? formatDateToYMD(values.beneficiary_dob)
          : "", // Handle empty or invalid input
      };
      // setRefreshBenficiary(false);
      values.beneficiary_live_at_my_address =
        values.beneficiary_live_at_my_address ? 1 : 0;
      console.log("transformedValues  =>", transformedValues);

      AddBeneficiary(transformedValues)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            const newBeneficiary = res.data;
            // Create a new beneficiary object for inherit_benficiaries
            const formattedBeneficiary = {
              id: newBeneficiary.id,
              beneficiary_first_name: newBeneficiary.beneficiary_first_name,
              beneficiary_last_name: newBeneficiary.beneficiary_last_name,
              beneficiary_type: "other", // Default type
              beneficiary_dob: newBeneficiary.beneficiary_dob,
              is_selected: false,
              percentage: null,
            };
            // Update the diesCurrentBeneficiary state
            setDiesBeneficiaries((prev) => ({
              ...prev,
              inherit_benficiaries: [
                ...prev.inherit_benficiaries,
                formattedBeneficiary,
              ],
            }));
            // Update Formik's save_beneficiaries field
            formik.setFieldValue("save_beneficiaries", [
              ...formik.values.save_beneficiaries,
              {
                beneficiary_id: newBeneficiary.id,
                beneficiary_percentage: "", // Default empty percentage
              },
            ]);
            toast.success("Beneficiary Added Successfully");
            setBeneficiaryModel(false);
            resetForm(); // This will clear the form fields
          } else {
             handleApiError(res,navigate);
          }
        })
        .catch((err) => {
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  return (
    <>
      {contentLoader ? (
        <Loader />
      ) : (
        <>
          <Header />
          <Toaster />
          <form onSubmit={formik.handleSubmit}>
            <div className="container">
              <div className="grid grid-cols-2 max-lg:grid-cols-1 mt-[20px]">
                <div>
                  <p className="font-semibold text-[22px] sm:text-[24px] md:text-[26px] lg:text-[28px] ">
                    Divide your estate
                  </p>
                  <p className="my-3 text-slate-500">
                    It’s best to choose one or more "back-up" beneficiaries in
                    case one of the people you’ve chosen dies before you. This
                    keeps your will up-to-date for longer.
                  </p>
                  <h4 className="font-semibold text-[16px] sm:text-[18px] md:text-[20px] lg:text-[22px]">
                    You’ve left{" "}
                    {
                      diesCurrentBeneficiary.beneficiary[
                        "beneficiary_first_name"
                      ]
                    }{" "}
                    {
                      diesCurrentBeneficiary.beneficiary[
                        "beneficiary_last_name"
                      ]
                    }{" "}
                    {diesCurrentBeneficiary.beneficiary_percentage}% of your
                    estate. What would you like to happen to that{" "}
                    {diesCurrentBeneficiary.beneficiary_percentage}% if partner
                    dies before you?
                  </h4>

                  <div className="my-5">
                    <div
                      className={`border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 currentDiv
                      ${radio == 0 ? "blueBorder" : `border-[#d7d7d7] `}   
                    `}
                      onClick={() => setRadio(0)} // Set radio state on div click
                    >
                      <div className="flex items-center justify-between mt-[16px]">
                        <div className="flex items-center gap-5">
                          <div>
                            <img src="/assets/images/icon-mascot.png" />
                          </div>
                          <div>
                            <h4 className="text-[16px]  font-semibold">
                              Give it to{" "}
                              {
                                diesCurrentBeneficiary.beneficiary[
                                  "beneficiary_first_name"
                                ]
                              }
                              ’s children (current and future)
                            </h4>
                          </div>
                        </div>
                        <div>
                          <input
                            name="if-dies"
                            id="if-dies"
                            onClick={() => setRadio(0)}
                            type="radio"
                            checked={radio === 0}
                            onChange={() => setRadio(0)} // Update state on change
                            className={`w-[20px] h-[20px]`}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="my-5">
                    <div
                      className={`border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 currentDiv
                      ${radio == 1 ? "blueBorder" : `border-[#d7d7d7] `}  
                    `}
                      onClick={() => setRadio(1)} // Set radio state on div click
                    >
                      <div className="flex items-center justify-between mt-[16px]">
                        <div className="flex items-center gap-5">
                          <div>
                            <img src="/assets/images/icon-mascot.png" />
                          </div>
                          <div>
                            <h4 className="text-[16px] font-semibold ">
                              Give it to someone else or a charity
                            </h4>
                          </div>
                        </div>
                        <div>
                          <input
                            name="if-dies"
                            id="if-dies"
                            onClick={() => setRadio(1)}
                            type="radio"
                            checked={radio === 1}
                            onChange={() => setRadio(1)} // Update state on change
                            className={`w-[20px] h-[20px]`}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {radio === 0 && (
                    <div className="bg-lavender my-5 flex gap-3  px-5 py-5">
                      <div className="mt-1">
                        <FaCircleInfo />
                      </div>
                      <div>
                        Adding information about your assets can help your
                        executors settle your estate quickly. Here you can
                        include bank accounts, stocks and shares or any pension
                        or life insurance plans you might have.
                      </div>
                    </div>
                  )}
                  {radio === 1 ? (
                    <>
                      <div className="font-semibold text-[16px] sm:text-[18px] md:text-[20px] lg:text-[22px]">
                        How would you like to split their{" "}
                        {diesCurrentBeneficiary.beneficiary_percentage}% share?
                      </div>
                      {diesCurrentBeneficiary?.inherit_charities_data?.map(
                        (item, index) => {
                          return (
                            <div className="charity-item-wrapper" key={index}>
                              <div className="flex">
                                <div className="border-2 p-5 my-5 Heading w-full">
                                  <div className="">
                                    <div className="gap-[20px] flex items-center">
                                      <div className="w-[15%] max-w-[100px]">
                                        <img
                                          src={item.charity_image}
                                          alt="Charity"
                                          className="w-full h-auto object-cover rounded-md"
                                        />
                                      </div>
                                      <div className="w-[55%]">
                                        <p className="font-bold text-[16px]">
                                          {item.charity_name}
                                        </p>
                                        <p className="text-[14px]">
                                          {item.charity_desc}
                                        </p>
                                      </div>
                                      <div className="w-[30%] sm:w-[50%] md:w-[30%] border-l-4 border-primary pl-3">
                                        <div className="flex items-center gap-2 relative">
                                          <input
                                            type="text"
                                            name={`save_charities[${index}].charity_percentage`}
                                            placeholder=""
                                            className="px-1 py-1 outline-none text-center rounded-md text-sm w-20 h-[70px] pr-6"
                                            value={
                                              formik.values.save_charities[
                                                index
                                              ]?.charity_percentage || ""
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (/^\d*$/.test(value)) {
                                                formik.setFieldValue(
                                                  `save_charities[${index}].charity_percentage`,
                                                  value
                                                );
                                                setDiesBeneficiaries(
                                                  (prevState) => {
                                                    const updatedCharities =
                                                      prevState.inherit_charities_data.map(
                                                        (charity, idx) =>
                                                          idx === index
                                                            ? {
                                                                ...charity,
                                                                percentage:
                                                                  value,
                                                              }
                                                            : charity
                                                      );
                                                    return {
                                                      ...prevState,
                                                      inherit_charities_data:
                                                        updatedCharities,
                                                    };
                                                  }
                                                );
                                              }
                                            }}
                                          />
                                          <span className="absolute right-1.5 md:right-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm md:text-base">
                                            %
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}

                      {diesCurrentBeneficiary?.inherit_benficiaries?.map(
                        (item, index) => {
                          return (
                            <div className="flex " key={index}>
                              <div className="border-2 p-5 my-5 Heading w-full">
                                <div className="">
                                  <div className="gap-[20px] flex items-center">
                                    <div className="w-[15%] max-w-[100px]">
                                      <img
                                        src="/assets/images/icon-mascot.png"
                                        alt="Beneficiary"
                                        className="w-full h-auto object-cover rounded-md"
                                      />
                                    </div>
                                    <div className="w-[55%]">
                                      <p className="font-bold">
                                        {item.beneficiary_first_name}{" "}
                                        {item.beneficiary_last_name}
                                      </p>
                                      <p>Beneficiary </p>
                                    </div>
                                    <div className="w-[30%] sm:w-[50%] md:w-[30%] border-l-4 border-primary pl-3">
                                      <div className="flex items-center relative">
                                        {/* <label className="font-medium">Amount:</label> */}
                                        <input
                                          type="text"
                                          name={`save_beneficiaries[${index}].beneficiary_percentage`}
                                          placeholder=""
                                          className="px-1 py-1 text-center outline-none rounded-md text-sm w-20 h-[70px] pr-6"
                                          value={
                                            formik.values.save_beneficiaries[
                                              index
                                            ]?.beneficiary_percentage || ""
                                          }
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*$/.test(value)) {
                                              formik.setFieldValue(
                                                `save_beneficiaries[${index}].beneficiary_percentage`,
                                                value
                                              );
                                              // Update diesCurrentBeneficiary state as well
                                              setDiesBeneficiaries(
                                                (prevState) => {
                                                  const updatedBeneficiaries =
                                                    prevState.inherit_benficiaries.map(
                                                      (benficiary, idx) =>
                                                        idx === index
                                                          ? {
                                                              ...benficiary,
                                                              percentage: value,
                                                            }
                                                          : benficiary
                                                    );
                                                  return {
                                                    ...prevState,
                                                    inherit_benficiaries:
                                                      updatedBeneficiaries,
                                                  };
                                                }
                                              );
                                            }
                                          }}
                                        />
                                        <span className="absolute right-1.5 md:right-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm md:text-base">
                                          %
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}
                      <div className="flex justify-between items-center my-5 w-full gap-5 flex-nowrap">
                        <div className="text-sm md:text-base">
                          Remaining to allocate:{" "}
                          <span className="font-bold">
                            {Math.max(100 - devideValue, 0)}%
                          </span>
                        </div>
                        <div className="flex items-center text-sm md:text-base">
                          <p className="mr-2">Allocated:</p>
                          <div className="relative">
                            <input
                              name="allocated_percentage"
                              type="text"
                              className="border-2 px-2 py-1 w-20 text-center"
                              value={devideValue}
                              readOnly
                            />
                            <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500">
                              %
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="my-5 ">
                        <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                          <div className="flex items-center justify-between mt-[16px]">
                            <div className="flex items-center gap-5">
                              <div>
                                <img src="/assets/images/icon-mascot.png" />
                              </div>
                              <div>
                                <h4 className="text-[16px] text-black font-muli font-bold ">
                                  Add someone new
                                </h4>
                                {/* <p>Leave part of your estate to a charity </p> */}
                              </div>
                            </div>
                            <div onClick={() => setBeneficiaryModel(true)}>
                              <Link>
                                <button className="border-2 hover:bg-primary hover:text-white transition-all ease-in rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold">
                                  Add
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="my-5 border-b-2 pb-5">
                        <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                          <div className="flex items-center justify-between mt-[16px]">
                            <div className="flex items-center gap-5">
                              <div>
                                <img src="/assets/images/icon-mascot.png" />
                              </div>
                              <div>
                                <h4 className="text-[16px] text-black font-muli font-bold ">
                                  Add a charity
                                </h4>
                                <p>Leave part of your estate to a charity </p>
                              </div>
                            </div>
                            <div onClick={() => setcharityModal(true)}>
                              <Link>
                                <button className="border-2 hover:bg-primary hover:text-white transition-all ease-in rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold">
                                  Add
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="flex justify-between my-5">
                    <Link
                      to={
                        diesCurrentBeneficiary.previous_id === 0
                          ? "/dashboard"
                          : `/make-will-online/estate/inheritance/${diesCurrentBeneficiary.previous_id}`
                      }
                    >
                      <button
                        type="button"
                        className="flex items-center justify-center gap-1 text-[20px] py-2 rounded-[10px] text-slate-500"
                      >
                        <FaAngleLeft />
                        Back
                      </button>
                    </Link>
                    <button
                      type="submit"
                      disabled={
                        radio === 0 ? false : radio === 1 && devideValue !== 100
                      }
                      className={`bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-2 
                        ${
                          radio === 1 && devideValue !== 100
                            ? "cursor-not-allowed opacity-50"
                            : ""
                        }
                      `}
                      onClick={() => {
                        setLoading(true);
                      }}
                    >
                      {loading ? <Spinner /> : "Next"}{" "}
                      {!loading ? <FaChevronRight /> : ""}
                    </button>
                  </div>
                </div>

                <div>
                  <div className=" bg-no-repeat max-lg:hidden">
                    <div className="fixed  w-[500px] right-[6%]">
                      <img src="/assets/images/6.png" alt="mascot" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <Modal
            open={charityModal}
            onClose={() => setcharityModal(false)}
            center
            classNames={{
              modal: "rounded-[5px] p-5 w-[75%]",
            }}
          >
            <div className="px-2">
              {/* <form> */}
              <div>
                <div>
                  <h4 className="text-black font-bold text-[22px] sm:text-[26px] lg:text-[28px] mt-[10px]">
                    Add a charity
                  </h4>
                  <p className="mt-2">
                    You can select any charity as your beneficiary
                  </p>
                </div>
                <div className="free_search_input" ref={freeSearchInputRef}>
                  <div className="mt-5">
                    <FloatingLabelInput
                      label="Search by name or charity number"
                      type="text"
                      id="search_input"
                      name="search_input"
                      placeholder=""
                      onChange={(e) => handleSearchCharity(e)}
                      value={searchInput}
                    />
                  </div>
                  <div className="dropdown-charity">
                    {searchInput && searchCharity?.length !== 0 ? (
                      <div className="bg-[#fff] h-[265px] overflow-y-auto -bottom-[130px] py-2 px-5 w-[100%] bg-white rounded-lg box-shadow-2">
                        {searchCharity?.map((data, index) => (
                          <div
                            className={`my-3 search-charity border-2 rounded-lg pb-3 px-4 ${
                              isSelected(data.id)
                                ? "blueBorder"
                                : "border-[#d7d7d7]"
                            }`}
                            key={data.id || `charity-${index}`}
                            onClick={() => handleDivClick(data)} // Handle div click
                          >
                            <div className="flex items-center justify-between mt-[10px]">
                              <div className="flex items-center gap-5">
                                <div className="w-[20%] sm:w-[10%]">
                                  <img
                                    src={data.charity_image}
                                    alt={data.charity_name || "Charity"}
                                    className="w-full object-cover h-auto rounded-md"
                                  />
                                </div>
                                <div>
                                  <h4 className="w-full text-black font-bold text-[14px] sm:text-[14px] lg:text-[16px] ">
                                    {data?.charity_name}
                                  </h4>
                                  <p className="w-full text-[14px] sm:text-[14px] lg:text-[16px]">
                                    Registered charity number:{" "}
                                    {data?.register_charity_number}
                                  </p>
                                </div>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  className="w-[20px] h-[20px]"
                                  checked={isSelected(data.id)}
                                  readOnly // Prevent direct modification
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <>
                        {selectedCharities?.map((data, index) => (
                          <div
                            className={`my-3 search-charity border-2 rounded-lg pb-3 px-4 ${
                              isSelected(data.id)
                                ? "blueBorder"
                                : "border-[#d7d7d7]"
                            }`}
                            key={data.id || `charity-${index}`}
                            onClick={() => handleDivClick(data)} // Handle div click
                          >
                            <div className="flex items-center justify-between mt-[10px]">
                              <div className="flex items-center gap-5">
                                <div className="w-[20%] sm:w-[10%]">
                                  <img
                                    src={data.charity_image}
                                    className="w-full object-cover h-auto rounded-md"
                                    alt={data.charity_name || "Charity"}
                                  />
                                </div>
                                <div>
                                  <h4 className="text-black font-bold text-[14px] sm:text-[14px] lg:text-[16px] ">
                                    {data?.charity_name}
                                  </h4>
                                  <p className="text-[14px] sm:text-[14px] lg:text-[16px]">
                                    Registered charity number:{" "}
                                    {data?.register_charity_number}
                                  </p>
                                </div>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  className="w-[20px] h-[20px]"
                                  checked={isSelected(data.id)} // Sync checkbox with state
                                  readOnly // Prevent direct modification
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                </div>
                <div className="flex justify-between">
                  <div className="py-5 ">
                    <button
                      type="button"
                      onClick={() => appendCharity(selectedCharities)} // Handle div click
                      className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1 add_selected_charity"
                    >
                      Add selected charity
                    </button>
                  </div>
                </div>
              </div>
              {/* </form> */}
            </div>
          </Modal>
          <Modal
            open={beneficiaryModel}
            onClose={onCloseModel}
            center
            className={"overflow-hidden"}
          >
            <div className="px-5">
              <form onSubmit={formikAddBeneficiary.handleSubmit}>
                <div>
                  <div>
                    <h4 className="text-[26px] text-black font-bold mt-[10px]">
                      Add someone new
                    </h4>
                    <p className="mt-2">
                      You can leave money or personal belongings to them
                    </p>
                  </div>
                  <div className="grid grid-cols-2 gap-5 ">
                    <div className="mt-5 mb-4 ">
                      <FloatingLabelInput
                        label="First Name"
                        type="text"
                        id="first_name"
                        name="beneficiary_first_name"
                        value={
                          formikAddBeneficiary.values.beneficiary_first_name
                        }
                        onChange={formikAddBeneficiary.handleChange}
                        onBlur={formikAddBeneficiary.handleBlur}
                        error={
                          formikAddBeneficiary.touched.beneficiary_first_name &&
                          formikAddBeneficiary.errors.beneficiary_first_name
                        }
                      />
                    </div>

                    <div className="mt-5 mb-4 ">
                      <FloatingLabelInput
                        label="Last Name"
                        type="text"
                        id="last_name"
                        name="beneficiary_last_name"
                        value={
                          formikAddBeneficiary.values.beneficiary_last_name
                        }
                        onChange={formikAddBeneficiary.handleChange}
                        onBlur={formikAddBeneficiary.handleBlur}
                        error={
                          formikAddBeneficiary.touched.beneficiary_last_name &&
                          formikAddBeneficiary.errors.beneficiary_last_name
                        }
                      />
                    </div>
                  </div>
                  <div className="mt-1 mb-4 ">
                    <FloatingLabelInput
                      label="Email address (optional)"
                      type="text"
                      id="new_guardian_email"
                      name="beneficiary_email"
                      value={formikAddBeneficiary.values.beneficiary_email}
                      onChange={formikAddBeneficiary.handleChange}
                      onBlur={formikAddBeneficiary.handleBlur}
                      error={
                        formikAddBeneficiary.touched.beneficiary_email &&
                        formikAddBeneficiary.errors.beneficiary_email
                      }
                    />
                  </div>
                  <div className="w-full mt-5">
                    <div className="relative w-full border-2 h-[60px] flex items-center">
                      <MaskedInput
                        mask={[
                          /\d/,
                          /\d/,
                          "/",
                          /\d/,
                          /\d/,
                          "/",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                        placeholder={
                          isFocused ||
                          formikAddBeneficiary.values.beneficiary_dob
                            ? "dd/mm/yyyy"
                            : ""
                        }
                        pipe={autoCorrectedDatePipe}
                        value={formikAddBeneficiary.values.beneficiary_dob}
                        onFocus={() => setIsFocused(true)}
                        onBlur={(e) => {
                          setIsFocused(false);
                          formikAddBeneficiary.handleBlur(e); // To ensure Formik registers field as "touched"
                        }}
                        onChange={(e) => {
                          formikAddBeneficiary.setFieldValue(
                            "beneficiary_dob",
                            e.target.value
                          );
                        }}
                        className="block text-black w-full px-[20px] h-full appearance-none focus:outline-none focus:ring-0 peer border-red-500 focus:border-red-500"
                        name="beneficiary_dob"
                      />

                      <label
                        htmlFor="dob"
                        className="absolute left-5 top-[16px]  text-gray-500 transition-all duration-200 transform text-[10px] -translate-y-3.5 peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5"
                      >
                        Date of birth(optional)
                      </label>
                    </div>
                  </div>
                  {formikAddBeneficiary.touched.beneficiary_dob &&
                  formikAddBeneficiary.errors.beneficiary_dob ? (
                    <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                      <FaInfoCircle />
                      <p className="text-white py-1 px-2 text-sm my-2">
                        {formikAddBeneficiary.errors.beneficiary_dob}
                      </p>
                    </div>
                  ) : null}

                  <div>
                    <h4 className="text-[16px] text-black font-bold mt-[36px]">
                      Add their address
                    </h4>
                    <p className="text-slate-500 my-2">
                      Adding address is optional
                    </p>
                  </div>
                  <div className="mt-1 mb-4 ">
                    <FloatingLabelInput
                      label="Enter their full address"
                      type="text"
                      id="beneficiary_location"
                      name="beneficiary_location"
                      value={formikAddBeneficiary.values.beneficiary_location}
                      onChange={formikAddBeneficiary.handleChange}
                      onBlur={formikAddBeneficiary.handleBlur}
                    />
                  </div>
                  <div className="mt-5">
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        className="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out"
                        checked={
                          formikAddBeneficiary.values
                            .beneficiary_live_at_my_address
                        }
                        onChange={() =>
                          formikAddBeneficiary.setFieldValue(
                            "beneficiary_live_at_my_address",
                            !formikAddBeneficiary.values
                              .beneficiary_live_at_my_address
                          )
                        }
                      />
                      <span className="ml-2 text-gray-700">
                        They live at my address?
                      </span>
                    </label>
                  </div>
                  <div className="flex justify-between">
                    <div className="py-5 ">
                      <button
                        type="submit"
                        className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1"
                      >
                        Add this person
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default PartnerDiesComp;
